"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Component = _interopRequireDefault(require("./Component"));
var _Settings = _interopRequireDefault(require("./Settings"));
var _Thumbnail = _interopRequireDefault(require("./Thumbnail"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  handle: 'upload',
  label: 'Upload Image',
  component: _Component["default"],
  settingsComponent: _Settings["default"],
  thumbnail: _Thumbnail["default"]
};